interface Note {
  freq: number;
  duration: number;
  delay: number;
}

// Créé uniquement après le premier geste utilisateur — jamais au chargement du module
let _ctx: AudioContext | null = null;

if (typeof document !== "undefined") {
  const unlock = () => {
    if (!_ctx) {
      try {
        _ctx = new AudioContext();
      } catch {
        return;
      }
    }
    if (_ctx.state === "suspended") void _ctx.resume();
  };
  document.addEventListener("click", unlock, { once: true });
  document.addEventListener("keydown", unlock, { once: true });
  document.addEventListener("touchstart", unlock, { once: true });
}

function playNotes(notes: Note[], volume = 0.18) {
  const ctx = _ctx;
  if (!ctx || ctx.state === "suspended") return;

  try {
    notes.forEach(({ freq, duration, delay }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = "sine";
      osc.frequency.value = freq;

      const t = ctx.currentTime + delay;
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(volume, t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, t + duration);

      osc.start(t);
      osc.stop(t + duration);
    });
  } catch {
    // ignore
  }
}

export const sound = {
  /** Chime deux tons — nouvelle notification */
  notification: () =>
    playNotes([
      { freq: 880, duration: 0.25, delay: 0 },
      { freq: 1100, duration: 0.25, delay: 0.12 },
    ]),

  /** Trois tons ascendants — session live démarrée */
  liveStart: () =>
    playNotes(
      [
        { freq: 523, duration: 0.2, delay: 0 },
        { freq: 659, duration: 0.2, delay: 0.15 },
        { freq: 784, duration: 0.3, delay: 0.3 },
      ],
      0.15,
    ),

  /** Deux tons descendants — session live terminée */
  liveEnd: () =>
    playNotes(
      [
        { freq: 784, duration: 0.2, delay: 0 },
        { freq: 523, duration: 0.3, delay: 0.15 },
      ],
      0.15,
    ),

  /** Ping court — participant rejoint */
  participantJoined: () => playNotes([{ freq: 880, duration: 0.15, delay: 0 }], 0.12),

  /** Ping grave — participant quitté */
  participantLeft: () => playNotes([{ freq: 600, duration: 0.15, delay: 0 }], 0.1),

  /** Ton d'alerte — enregistrement démarré */
  recordingStarted: () =>
    playNotes(
      [
        { freq: 660, duration: 0.15, delay: 0 },
        { freq: 880, duration: 0.2, delay: 0.12 },
      ],
      0.14,
    ),
};
